import React, { useEffect, useState } from "react";
import axios from "axios";

import "./WhatsappCrm.css";

import ConversationList from "./ConversationList";
import ChatWindow from "./ChatWindow";
import CustomerDetails from "./CustomerDetails";

export default function WhatsappCRM() {
    

    const [loading, setLoading] = useState(false);

    const [conversations, setConversations] = useState([]);

    const [filteredConversations, setFilteredConversations] = useState([]);

    const [selectedConversation, setSelectedConversation] =
        useState(null);

    const [messages, setMessages] = useState([]);

    const [search, setSearch] = useState("");

    const [sending, setSending] = useState(false);
    const [authorized, setAuthorized] = useState(false);

const [password, setPassword] = useState("");

    /* ----------------------------------------
            Initial Load
    -----------------------------------------*/

    useEffect(() => {

        loadConversations();

    }, []);
    useEffect(() => {

    const auth = localStorage.getItem(
        "whatsapp_admin"
    );

    if (auth === "true") {

        setAuthorized(true);

    }

}, []);
    /* ----------------------------------------
            Search Filter
    -----------------------------------------*/

    useEffect(() => {

        if (!search.trim()) {

            setFilteredConversations(conversations);

            return;

        }

        const result = conversations.filter((item) => {

            return (

                item.name
                    ?.toLowerCase()
                    .includes(search.toLowerCase())

                ||

                item.phoneNumber
                    ?.includes(search)

            );

        });

        setFilteredConversations(result);

    }, [search, conversations]);

    /* ----------------------------------------
            Load Conversations
    -----------------------------------------*/

    const loadConversations = async () => {

        try {

            setLoading(true);

            const res =
                await axios.get(

                    "/api/whatsapp/conversations"

                );

            const data =
                res.data.conversations || [];

            setConversations(data);

            setFilteredConversations(data);

            if (

                data.length > 0 &&

                !selectedConversation

            ) {

                loadMessages(

                    data[0]

                );

            }

        }

        catch (error) {

            console.error(error);

        }

        finally {

            setLoading(false);

        }

    };

    /* ----------------------------------------
            Load Messages
    -----------------------------------------*/

    const loadMessages = async (

        conversation

    ) => {

        try {

            setSelectedConversation(

                conversation

            );

            const res =
                await axios.get(

                    `/api/whatsapp/messages/${conversation.phoneNumber}`

                );

            setMessages(

                res.data.messages || []

            );

        }

        catch (error) {

            console.error(error);

        }

    };

    /* ----------------------------------------
            Send Message
    -----------------------------------------*/

    const sendMessage = async (

        message

    ) => {

        if (

            !message ||

            !message.trim()

        ) return;

        try {

            setSending(true);

            await axios.post(

                "/api/whatsapp/send",

                {

                    phoneNumber:
                        selectedConversation.phoneNumber,

                    name:
                        selectedConversation.name,

                    message

                }

            );

            await loadMessages(

                selectedConversation

            );

            await loadConversations();

        }

        catch (error) {

            console.error(error);

        }

        finally {

            setSending(false);

        }

    };

    /* ----------------------------------------
            Refresh Button
    -----------------------------------------*/

    const refreshChats = () => {

        loadConversations();

    };

    const verifyPassword = async () => {

    try {

        const res = await axios.post(

            "/api/admin-login",

            {

                password

            }

        );

        if (res.data.success) {

            localStorage.setItem(

                "whatsapp_admin",

                "true"

            );

            setAuthorized(true);

        }

    } catch (error) {

        alert(

            error.response?.data?.message ||

            "Wrong Password"

        );

    }

};
        /* ----------------------------------------
            JSX
    -----------------------------------------*/
if (!authorized) {

    return (

        <div className="admin-login">

            <div className="admin-login-card">

                <h2>

                    WhatsApp CRM

                </h2>

                <input

                    type="password"

                    placeholder="Enter Password"

                    value={password}

                    onChange={(e) =>

                        setPassword(

                            e.target.value

                        )

                    }

                />

                <button

                    onClick={verifyPassword}

                >

                    Login

                </button>

            </div>

        </div>

    );

}
    return (

        <div className="wa-crm">

            {/* -----------------------------
                Left Sidebar
            ------------------------------ */}

            <ConversationList

                loading={loading}

                search={search}

                setSearch={setSearch}

                conversations={filteredConversations}

                selectedConversation={selectedConversation}

                refreshChats={refreshChats}

                onSelect={loadMessages}

            />

            {/* -----------------------------
                Chat Window
            ------------------------------ */}

            <ChatWindow

                conversation={selectedConversation}

                messages={messages}

                onSend={sendMessage}

                sending={sending}

            />

            {/* -----------------------------
                Customer Details
            ------------------------------ */}

            <CustomerDetails

                conversation={selectedConversation}

            />

        </div>

    );

}